<template>
  <div class="asset-count">{{ assetCount }}</div>
</template>
<script>
export default {
  name: "AssetCount",
  props: {
    assetCount: { type: Number, default: 0 }
  }
};
</script>
<style lang="less" scoped>
.asset-count {
  height: 22px;
  line-height: 20px;
  text-align: right;
  background: #2e2e35 url("~@/assets/zs_imgs/ck-mutil-price-icon.png") no-repeat;
  background-position: 4px center;
  background-size: 20px 12px;
  border-radius: 20px;
  padding: 2px 8px 2px 30px;
  color: #fff;
  margin-left: auto;
}
</style>
